import { loggerCreator } from "app/utils/logger";
const moduleLogger = loggerCreator(__filename);

import * as ajv from "ajv";
import { CQLOUD_LOGIN_DOMAIN } from "app/utils/authorizationValidation/authorizationValidation";

export class Ajax {
  static get = async (targetUrl: string, options?: RequestInit, loginOnFailue = true): Promise<Response> => {
    const response = await fetch(targetUrl, {
      method: "get",
      credentials: "include",
      ...options,
    });

    if ([401, 403].includes(response.status) && loginOnFailue) {
      const loginUrl = Ajax.combineUrls(`https://${CQLOUD_LOGIN_DOMAIN}`, "login");
      const loginUrlApi = loginUrl + "?api=true";
      const tokenRefreshResponse = await fetch(loginUrlApi, {
        method: "get",
        credentials: "include",
      });
      if ([401, 403].includes(tokenRefreshResponse.status)) {
        moduleLogger.warn("Authorization failed - redirecting to login");
        window.location.href = `${loginUrl}?next=${encodeURIComponent(location.href)}`;

        return Promise.reject();
      } else {
        return Ajax.get(targetUrl, options, false);
      }
    } else {
      return response;
    }
  };

  static getJson = async (targetUrl: string): Promise<any> => {
    const response = await Ajax.get(targetUrl, {
      headers: new Headers({ Accept: "application/json" }),
    });

    return await response.json();
  };

  static async getJsonWithSchema(targetUrl: string, schema: Object): Promise<Object> {
    const json = await this.getJson(targetUrl);
    const schemaValidator = ajv();
    const isSchemaValid = schemaValidator.validate(schema, json);
    if (!isSchemaValid) {
      throw new Error("JSON doesn't match schema: " + schemaValidator.errors);
    }

    return json;
  }

  static combineUrls(...args: string[]) {
    return args
      .map((part, i) => {
        if (i === 0) {
          return part.trim().replace(/[\/]*$/g, "");
        } else {
          return part.trim().replace(/(^[\/]*|[\/]*$)/g, "");
        }
      })
      .filter(x => x.length)
      .join("/");
  }
}



// WEBPACK FOOTER //
// ./app/utils/ajax.ts